/* The Horn - brew chai page behaviour */

(function () {
  var root = document.querySelector('[data-hbc]');
  if (!root) return;

  var steps  = Array.prototype.slice.call(root.querySelectorAll('.hbc-step'));
  var frames = Array.prototype.slice.call(root.querySelectorAll('.hbc-frame'));
  var rail   = Array.prototype.slice.call(root.querySelectorAll('.hbc-rail button'));
  var badge  = root.querySelector('[data-badge]');
  var labels = ['Step 01 · Add The Chai', 'Step 02 · Let It Simmer', 'Step 03 · Add The Milk', 'Step 04 · Strain & Sip'];
  var current = -1;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sticky = root.querySelector('.hbc-sticky');

  // On phones the sticky column is display:none. Never touch those videos there,
  // or we burn mobile data loading clips nobody can see.
  function stickyVisible() {
    return !!(sticky && sticky.offsetParent !== null);
  }

  function setActive(i) {
    if (i === current) return;
    current = i;

    var live = stickyVisible();
    frames.forEach(function (f, n) {
      var on = n === i;
      f.setAttribute('data-active', on ? 'true' : 'false');
      var v = f.querySelector('video');
      if (!v) return;
      if (on && live && !reduce) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    });

    steps.forEach(function (s, n) {
      s.setAttribute('data-active', n === i ? 'true' : 'false');
    });

    rail.forEach(function (b, n) {
      b.setAttribute('aria-current', n === i ? 'true' : 'false');
    });

    if (badge && labels[i]) badge.textContent = labels[i];

    // Warm the next clip while the reader is still on this one, so moving
    // to the next step does not start a download from cold.
    var nxt = frames[i + 1] && frames[i + 1].querySelector('video');
    if (nxt && nxt.preload !== 'metadata' && nxt.preload !== 'auto') {
      nxt.preload = 'metadata';
      try { nxt.load(); } catch (e) {}
    }
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          setActive(parseInt(e.target.getAttribute('data-step'), 10));
        }
      });
    }, { rootMargin: '-48% 0px -48% 0px', threshold: 0 });
    steps.forEach(function (s) { io.observe(s); });
  }

  // Mobile inline clips and the iced cards are plain lazy videos. Warm each
  // one shortly before it reaches the viewport rather than at scroll time.
  if ('IntersectionObserver' in window) {
    var warm = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var v = e.target;
        if (v.preload !== 'metadata' && v.preload !== 'auto') {
          v.preload = 'metadata';
          try { v.load(); } catch (err) {}
        }
        if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        warm.unobserve(v);
      });
    }, { rootMargin: '400px 0px' });
    root.querySelectorAll('.hbc-step-media video, .hbc-icard-media video')
        .forEach(function (v) { warm.observe(v); });
  }

  rail.forEach(function (b) {
    b.addEventListener('click', function () {
      var t = steps[parseInt(b.getAttribute('data-goto'), 10)];
      if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });
  });

  // Rotating a phone can cross the layout breakpoint, so re-apply the active
  // state to start or stop the sticky video accordingly.
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      var i = current;
      current = -1;
      setActive(i < 0 ? 0 : i);
    }, 180);
  }, { passive: true });

  // Play mobile step videos + iced step tiles only while on screen
  var inline = Array.prototype.slice.call(
    root.querySelectorAll('.hbc-step-media video, .hbc-icard-media video')
  );
  if (inline.length && 'IntersectionObserver' in window && !reduce) {
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var p = e.target.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          e.target.pause();
        }
      });
    }, { threshold: 0.35 });
    inline.forEach(function (v) { io2.observe(v); });
  }

  setActive(0);
})();
